import NestedForm from "stimulus-rails-nested-form"

// Connects to data-controller="nested-form"
export default class extends NestedForm {
  static targets = ["field"]

  connect() {
    super.connect()
    this.index = this.fieldTargets.length - 1
  }

  add(event) {
    event.preventDefault()

    this.appendField()
  }

  appendField(fieldValue = null) {
    this.index += 1
    const template = this.templateTarget.innerHTML

    const content = template.replace(/NEW_INDEX/g, this.index + 1)

    this.targetTarget.insertAdjacentHTML("beforeend", content)
    this.updateFieldIndexes()

    const appendedField = this.fieldTargets[this.fieldTargets.length - 1]

    if (fieldValue !== null && fieldValue !== undefined)
      this.applyFieldValue(appendedField, fieldValue)

    return appendedField
  }

  applyFieldValue(field, fieldValue) {
    const input = field.querySelector("input[type='text'], textarea")

    if (!input)
      return

    input.value = fieldValue
  }

  remove(event) {
    event.preventDefault()

    const wrapper = event.target.closest(this.wrapperSelectorValue)

    if (wrapper) {
      this.index -= 1
      wrapper.remove()
      this.updateFieldNumbers()
      this.updateFieldIndexes()
    }
  }

  updateFieldNumbers() {
    this.fieldTargets.forEach((field, index) => {
      const number = field.querySelector("[data-nested-form-number]")
      if (number) {
        number.textContent = index + 1
      }
    })
  }

  updateFieldIndexes() {
    const regex = /(\[\w+\]\[)(\d+)(\]\[\w+\])/

    this.fieldTargets.forEach((field, index) => {
      field.querySelectorAll("[data-nested-form-index]").forEach(input => {
        if (regex.test(input.name)) {
          input.name = input.name.replace(regex, `$1${index}$3`)
        }
      })
    })
  }
}
